import http from './axios';

export default class CronjobServices {
  private readonly total_api = '/v1/cronjob/count-job';
  private readonly info_api = '/v1/cronjob/info';
  private readonly list_api = '/v1/cronjob/list';
  private readonly page_api = '/v1/cronjob/page';
  private readonly remove_api = '/v1/cronjob/delete';
  private readonly update_api = '/v1/cronjob/update';
  private readonly runBatch_api = '/v1/cronjob/run-batch';
  private readonly all_record_api = '/v1/jobrecord/count-job-record';
  private readonly group_record_api = '/v1/jobrecord/count-job-record-by-group';
  private readonly rate_api = '/v1/jobrecord/count-job-rate';
  private readonly record_list_api = '/v1/jobrecord/list';
  private readonly record_page_api = '/v1/jobrecord/page';


  constructor() {}

  async getTotal(params?: object): Promise<any> {
    let res: any = await http.get(this.total_api, { params: params });
    return res.payload;
  }
  
  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getPage(params?: object): Promise<any> {
    let res: any = await http.get(this.page_api, { params: params });
    return res.payload;
  }

  async getRecordList(params?: object): Promise<any> {
    let res: any = await http.get(this.record_list_api, { params: params });
    return res.payload;
  }

  async getRecordPage(params?: object): Promise<any> {
    let res: any = await http.get(this.record_page_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async update(data: any): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async run(data: any): Promise<boolean> {
    let res: any = await http.post(this.runBatch_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  // 作业运行总览
  async getTotalRecord(params?: object): Promise<any> {
    let res: any = await http.get(this.all_record_api, { params: params });
    return res.payload;
  }

  async getTotalGroupRecord(params?: object): Promise<any> {
    let res: any = await http.get(this.group_record_api, { params: params });
    return res.payload;
  }

  async getRecordRate(params?: object): Promise<any> {
    let res: any = await http.get(this.rate_api, { params: params });
    return res.payload;
  }

}
